import React, { useState } from "react";
import PhoneInput from "react-phone-number-input";
import hidePass from "../../assets/images/hidePass.svg";
import showPassImg from "../../assets/images/showPass.svg";
import { Navbar } from "../../component/navbar";
import { Footer } from "../../component/footer";
import "react-phone-number-input/style.css";
import api from "../../api";
import { notify } from "../../utils/toast";

export const ContactUS = () => {
  const [showPass, setShowPass] = useState(false);
  const [loader, setLoader] = useState(false);
  const [phoneNum, setPhoneNum] = useState("");
  const [data, setData] = useState({
    email: "",
  });

  const onTextChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const validate = () => {
    if (!data?.firstName) {
      return "Please Enter First Name.";
    }
    if (!data?.lastName) {
      return "Please Enter Last Name.";
    }
    if (!data?.email) {
      return "Please Enter Email Address.";
    }
    if (!phoneNum) {
      return "Please Enter Email Address.";
    }
    if (phoneNum.length > 16) {
      return "Invalid Phone Number ";
    }
    if (!data?.message) {
      return "Please Enter Message.";
    }
    return false;
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const checkValidation = validate();
      if (checkValidation) {
        notify.info(checkValidation);
        return;
      }
      setLoader(true);
      let payload = {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        message: data.message,
        phone: phoneNum,
      };
      const res = await api.contactSubmit(payload);
      console.log(res);
      if (res?.success) {
        setData({});
        notify.success(
          "Thank you for contacting us. We will get back to you shortly.",
        );
      } else {
        notify.error("Something Went Wrong");
      }
      setLoader(false);
    } catch (error) {
      console.log(error?.message);

      notify.error(error?.message || "Something Went Wrong");
      setLoader(false);
    }
  };

  return (
    <div className="homePage">
      <Navbar />
      <div className="container">
        <div className="contactPage">
          <h4 className="section-head">Contact us</h4>
          <h2 className="section-title text-center mb-45">Get in touch</h2>
          <div className="tagline">
            We’d love to hear from you. Please fill out this form.
          </div>
          <div className="contact-form signup-form">
            <form
              noValidate
              id="contactForm"
              className="ng-invalid ng-dirty ng-touched"
              onSubmit={onSubmit}
            >
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>First Name</label>
                    <input
                      onChange={(e) => onTextChange(e)}
                      type="text"
                      name="firstName"
                      required
                      placeholder="First Name"
                      className="form-control ng-dirty ng-invalid ng-touched"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Last Name</label>
                    <input
                      onChange={(e) => onTextChange(e)}
                      type="text"
                      name="lastName"
                      required
                      placeholder="Last Name"
                      className="form-control ng-dirty ng-invalid ng-touched"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label>Email</label>

                    <input
                      onChange={(e) => onTextChange(e)}
                      type="text"
                      name="email"
                      id="email"
                      required
                      placeholder="Email"
                      className="form-control ng-dirty ng-invalid ng-touched"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group phone">
                    <label>Phone Number</label>
                    <PhoneInput
                      className="form-control PhoneInput"
                      international
                      countryCallingCodeEditable={false}
                      value={phoneNum}
                      onChange={setPhoneNum}
                      placeholder="Phone Number"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group phone">
                    <label>Message</label>
                    <textarea
                      rows={4}
                      onChange={(e) => onTextChange(e)}
                      type="text"
                      name="message"
                      required
                      placeholder="Message"
                      className="form-control"
                    ></textarea>
                  </div>
                </div>
                {/* <div className="col-12">
                  <div className="agree">
                    You agree to our friendly{" "}
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      privacy policy.
                    </a>
                  </div>
                </div> */}

                <div className="col-12 ">
                  <button type="submit" className="themeBtn px-5">
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
